module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en-US":{"title":"","copy":{"description":""}},"es-MX":{"title":"Invitación","copy":{"description":"Con la bendición de Dios y de nuestros padres, te invitamos a celebrar nuestra boda."}}}')
  delete Component.options._Ctor
}
